import { $http, Constants } from "@/store/actions/constants"

export const MarketplaceAction = {
    find: ({ commit, state }, search) => {
        return $http.get(url, { ...state.authHeader, params: search }).then(r => {
            if (r.status === 200) {
                commit("SET_MARKETPLACE_OFFER", r.data)
            }
        })
    },

    saveSearch: ({ commit, state }, search) => {
        sessionStorage.setItem("search", JSON.stringify(search));
    },
    getSearch: ({ commit, state }) => {
        const data = sessionStorage.getItem("search")
        if (data) {
            const search = JSON.parse(data)
            commit("SET_MARKETPLACE_SEARCH", search)
        }
    },
    info: ({ commit, state }) => {
        return $http.get(`${url}/info`, state.authHeader);     
    },
}

const url = `${Constants.BaseURL}/benefit/marketplace`;
